import React, { useState } from 'react';

import { RelatedCareerSection } from 'labxchange-client';
import { WrappedMessage } from '../../../../utils';
import messages from '../../../displayMessages';
import CareerCard from '../CareerCard';

interface RelatedCareerProps {
  relatedCareerSections: RelatedCareerSection[];
}

const RelatedCareers: React.FC<RelatedCareerProps> = ({
  relatedCareerSections,
}) => {
  return (
    <div className='related-career-section'>
      <h2>
        {' '}
        <WrappedMessage message={messages.relatedCareersHeadingText} />{' '}
      </h2>
      {relatedCareerSections.map((relatedSection, i) => (
        <div className='related-careers' key={i}>
          <span>{relatedSection.sectionTitle}</span>
          <div className='related-career-list'>
            {relatedSection.relatedCareers?.map((career) => (
              <CareerCard career={career} key={career.id} showImage={true} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RelatedCareers;
